export const DEFAULT_FONT_NAME = "PretendardVariable-v1";

export const RICH_TEXT_EMPTY_VALUE = "<p><br></p>";
